import React from 'react';
import { CustomRoute } from 'util/hook/useRouter';

import { getAdultCheckUpReportList } from 'models/adultCheckUpReport';
import { ROUTE_PATHS } from 'models/sideMenu';
import { checkAuthGuard } from 'models/auth';

// import InpatientListInner from './Inner';

const routes: CustomRoute = {
	path: '/adult-checkup-report',
	components: () => [],
	render: (_, children) => children,
	onEnter: async ({ next }) => {
		const children = await next();
		return children;
	},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'inpatientList' */ './component')],
			render: ([AdultCheckupReport]) => <AdultCheckupReport />,
			onEnter: async ({ store, next }) => {
				console.log('on Enter Adult Checkup Report');
				const allowEnter = checkAuthGuard(store, `/${ROUTE_PATHS.ADULT_CHECKUP_REPORT}`);
				if (allowEnter) {
					// await store.dispatch(getAdultCheckUpReportList());
				}
				const children = await next();
				return children;
			},
		},
		// InpatientListInner,
	],
};
export default routes;
